// ─── Spinner component ─────────────────────────────────────────────────────────

import React from 'react';
import { cn } from '../../utils/helpers';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'white' | 'navy' | 'success';
  /**
   * Accessible label. Pass `null` inside a control that already names itself —
   * a button's accessible name is computed from its contents, so a labelled
   * spinner in there turns "Retry" into "Loading Retry" for the whole time the
   * action is in flight. The control's own `aria-busy` reports the state.
   */
  label?: string | null;
  className?: string;
}

const sizeClasses = { sm: 'w-4 h-4', md: 'w-6 h-6', lg: 'w-8 h-8' };
const colorClasses = {
  white:   'border-white/30 border-t-white',
  navy:    'border-primary/20 border-t-primary',
  success: 'border-success/20 border-t-success',
};

const Spinner: React.FC<SpinnerProps> = ({ size = 'md', color = 'navy', label = 'Loading', className }) => (
  <span
    {...(label === null
      ? { 'aria-hidden': true as const }
      : { role: 'status', 'aria-label': label })}
    className={cn(
      'inline-block rounded-full border-2 animate-spin',
      sizeClasses[size],
      colorClasses[color],
      className
    )}
  />
);

export default Spinner;
